import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { ChangeEvent, useEffect, useState } from "react";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormatDateIso } from "utils/dateUtils";
import {
  resetOutputValue,
  selectState,
  setNewOutputPopover,
  setSelectedPartnerId,
} from "../../Input/inputSlice";
// import "../output-dialog.scss";
import { useAppDispatch } from "hooks/hooks";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { useSelector } from "react-redux";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesCB from "Dashboard/scenes/ConcreteBase/styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PartnerSimpleSelect from "Dashboard/scenes/Partners/components/PartnerSimpleSelect";
import DriverSelectCreate from "Dashboard/scenes/Stock/secenes/Input/components/DriverSelectCreate";
import VehicleSelectCreate from "Dashboard/scenes/Stock/secenes/Input/components/VehicleSelectCreate";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo } from "utils/authUtil";
import { CONCRETE_BASE_MODULE_NAME } from "Dashboard/scenes/ConcreteBase/domain/ConcreteBaseModule";
import { IConcreteBaseOutputCreate } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseOutputCreate";
import { IRepository } from "Dashboard/scenes/ConcreteBase/domain/IRepository";
import { IInputItemToTake } from "Dashboard/scenes/ConcreteBase/domain/IInputItemToTake";
import { IOption } from "Dashboard/domain/IOption";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IConcreteBaseOutputCreate>;
  register: UseFormRegister<IConcreteBaseOutputCreate>;
  getValues: UseFormGetValues<IConcreteBaseOutputCreate>;
  setValue: UseFormSetValue<IConcreteBaseOutputCreate>;
  control: Control<IConcreteBaseOutputCreate, any>;
  errors: Partial<FieldErrorsImpl<IConcreteBaseOutputCreate>>;
  reset: () => void;
  driverValue: IOption | undefined;
  setDriverValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  vehicleValue: IOption | undefined;
  setVehicleValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  partnerValue: IOption | undefined;
  setPartnerValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
};

const NewConcreteBaseOutputPopover = (props: IProps) => {

  const { outputValues, selectedPartner, productionDate } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);
  const canEditDate = hasFullAccessTo(user, CONCRETE_BASE_MODULE_NAME);

  const resetForm = () => {
    reset();
    dispatch(setSelectedPartnerId(undefined));
    dispatch(setNewOutputPopover({ isOpen: false }));
  };

  const closeDialog = () => {
    resetForm();
  };

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [repository, setRepository] = useState<IRepository | undefined>(undefined);
  const [itemsToTake, setItemsToTake] = useState<IInputItemToTake[]>([]);

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    errors,
    reset,
  } = props;

  useEffect(() => {
    setValue("date", productionDate ?? FormatDateIso(new Date()));
  }, [setValue, productionDate]);

  const onValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.setType(event.target.value);
  };

  useEffect(() => {
    if (outputValues.repository) {
      setRepository(outputValues.repository);
      const itemsToTakeTemp: IInputItemToTake[] = [];
      for (const [key, value] of Object.entries(outputValues.map)) {
        itemsToTakeTemp.push({
          inputId: Number(key),
          quantity: value || 0,
        });
      }
      setItemsToTake(itemsToTakeTemp);
    }
  }, [outputValues.repository]);

  const onSubmit = async (data: IConcreteBaseOutputCreate) => {
    try {
      if (repository === undefined) {
        toast.warning("Neočekivana greška! Da li ste izabrali stavku koju izdajete? Javite se podršci za pomoć.");
        return;
      }
      if (props.type === "Project") {
        await concreteBaseService.createOutputProject({
          repositoryId: repository.repositoryId || 0,
          note: data.note,
          projectId: data.projectId,
          projectIdOverride: data.projectIdOverride,
          date: data.date,
          takenAwayByDriverId: data.takenAwayByDriverId,
          takenAwayByVehicleId: data.takenAwayByVehicleId,
          itemsToTake: itemsToTake,
        });
      } else {
        await concreteBaseService.createOutputPartner({
          repositoryId: repository.repositoryId || 0,
          note: data.note,
          partnerId: data.partnerId,
          date: data.date,
          takenAwayByDriverId: data.takenAwayByDriverId,
          takenAwayByVehicleId: data.takenAwayByVehicleId,
          itemsToTake: itemsToTake,
        });
      }
      navigate("/betonska-baza/output");
      toast.success("Izdavanje je uspesno izvrseno.");
      dispatch(resetOutputValue());
      closeDialog();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form className={`${classesCB.newCBOutputPopover} ${classes.basicPopover}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>magacin</label>
          <div>
            <input className={classes.subInput}
              value={repository?.name}
              disabled />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>sledeci br otpremnice</label>
          <div>
            <input className={classes.subInput}
              value={repository?.billOfLandingSequence} disabled />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>sledeci br trebovanja</label>
          <div>
            <input className={classes.subInput}
              value={repository?.requisitionSequence} disabled />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir} ${classesCB.paragraph}`}>
          <label className={classes.mr5}>izdajem za</label>
          <div className={classesCB.radioButtonsDiv}>
            <input
              type="radio"
              value="Project"
              checked={props.type === "Project"}
              onChange={onValueChange}
              name="type"
            />
            <label>projekat</label>
            <input
              type="radio"
              value="Partner"
              checked={props.type === "Partner"}
              onChange={onValueChange}
              name="type"
            />
            <label>saradniku</label>
          </div>
        </div>
      </div>
      {props.type === "Project" && (
        <>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}
              ${errors.projectId ? classes.itemError : ""}`}>
              <label className={classes.mr5}>izdajem za projekat</label>
              <Controller
                name="projectId"
                control={control}
                defaultValue={undefined}
                rules={{ required: true, }}
                render={({ field: { onChange } }) => (
                  <ProjectSelect
                    value={getValues("projectId")}
                    customStyles={styles.customStyleClassic}
                    error={errors.projectId}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>

          <div className={`${classes.row} ${classesCB.paragraph}`}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>ime na otpremnici<br />i trebovanju</label>
              <Controller
                name="projectIdOverride"
                control={control}
                defaultValue={undefined}
                render={({ field: { onChange } }) => (
                  <ProjectSelect
                    value={getValues("projectIdOverride")}
                    customStyles={styles.customStyleClassic}
                    error={errors.projectIdOverride}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>
        </>
      )}
      {props.type === "Partner" && (
        <>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}
              ${errors.partnerId ? classes.itemError : ""}`}>
              <label className={classes.mr5}>*izdajem saradniku</label>
              <Controller
                name="partnerId"
                control={control}
                defaultValue={undefined}
                render={({ field: { onChange } }) => (
                  <PartnerSimpleSelect
                    value={props.partnerValue}
                    setValue={props.setPartnerValue}
                    customStyles={styles.customStyleClassic}
                    error={errors.partnerId}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>mesto</label>
              <div>
                <input
                  className={classes.subInput}
                  value={
                    selectedPartner
                      ? selectedPartner.municipality
                        ? selectedPartner.municipality.name
                        : ""
                      : ""
                  }
                  disabled
                />
              </div>
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>adresa</label>
              <div>
                <input className={classes.subInput}
                  value={selectedPartner?.address}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>pib</label>
              <div>
                <input className={classes.subInput}
                  value={selectedPartner?.id}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className={classesCB.paragraph}></div>
        </>
      )}

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>odvezao</label>
          <Controller
            name="takenAwayByDriverId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <DriverSelectCreate
                value={props.driverValue}
                setValue={props.setDriverValue}
                error={errors.takenAwayByDriverId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>registracija</label>
          <Controller
            name="takenAwayByVehicleId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <VehicleSelectCreate
                vehicleValue={props.vehicleValue}
                setVehicleValue={props.setVehicleValue}
                customStyles={styles.customStyleClassic}
                error={errors.takenAwayByVehicleId}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      {canEditDate &&
        <div className={classes.row}>
          <div className={`${classes.col} ${classes.rowDir}`}>
            <label className={classes.mr5}>datum</label>
            <Controller
              control={control}
              name="date"
              defaultValue={productionDate ?? FormatDateIso(new Date())}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <div>
                  <DatePicker
                    onChange={(date) =>
                      onChange(date ? FormatDateIso(date) : undefined)
                    }
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="dd.MM.yyyy"
                    selected={value ? new Date(value) : null}
                    className={`${classes.itemBorder} ${classes.dateItem}
                      ${errors.date ? classes.itemError : ""}`}
                  />
                </div>
              )}
            />
          </div>
        </div>
      }

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>napomena</label>
          <textarea {...register("note")} />
        </div>
      </div>

      <div className={classes.row}>
        {/* {type === "Partner" && (
          <div>
            <div>
              * ako su polja sa podacima saradnika {<br />}prazna
              podrazumeva da izdajemo artikle{<br />} sopstvenom preduzeću
            </div>
          </div>
        )} */}
        <div className={`${classes.buttons}`}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewConcreteBaseOutputPopover;
